if (!customElements.get('twt-cart-bundle')) {
  customElements.define(
    'twt-cart-bundle',
    class TwtCartBundle extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-bundle-add]');
        this.status = this.querySelector('[data-bundle-status]');
        this.button?.addEventListener('click', () => this.addBundle());
      }

      async addBundle() {
        const ids = (this.dataset.variantIds || '').split(',').map((id) => Number(id.trim())).filter(Boolean);
        if (!ids.length || !this.button) return;

        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');

        try {
          const bundleName = this.dataset.bundleName || 'Frequently Bought Together';
          const response = await fetch(`${this.dataset.addUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: ids.map((id) => ({
                id,
                quantity: 1,
                properties: { _bundle: bundleName },
              })),
            }),
          });
          if (!response.ok) throw new Error('Unable to add the bundle.');
          this.button.textContent = 'Products added to your cart';
          this.button.removeAttribute('aria-busy');
          this.classList.add('is-added');
          if (this.status) this.status.textContent = 'Products added to your cart';

          const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.setTimeout(() => window.location.reload(), prefersReducedMotion ? 350 : 1600);
        } catch (error) {
          if (this.status) this.status.textContent = error.message;
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    }
  );
}

if (!customElements.get('twt-cart-discount')) {
  customElements.define(
    'twt-cart-discount',
    class TwtCartDiscount extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[name="discount"]');
        this.button = this.querySelector('[data-discount-apply]');
        this.status = this.querySelector('[data-discount-status]');
        this.button?.addEventListener('click', () => this.applyDiscount());
        // The drawer re-renders right after a code is tried: keep the answer the
        // customer just got (mainly "not valid", which Liquid cannot know).
        const last = window.twtLastDiscountStatus;
        if (last && Date.now() - last.at < 10000 && this.status) this.status.textContent = last.text;
        this.input?.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            this.applyDiscount();
          }
        });
      }

      async applyDiscount() {
        const code = this.input?.value.trim();
        if (!code || !this.button) return;

        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        if (this.status) this.status.textContent = this.dataset.textApplying || 'Applying…';

        try {
          const response = await fetch(`${this.dataset.updateUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: code }),
          });
          if (!response.ok) throw new Error(this.dataset.textInvalid || "This code isn't valid.");
          const cart = await response.json();
          const applied = (cart.discount_codes || []).find(
            (entry) => entry.code.toLowerCase() === code.toLowerCase()
          );

          if (this.status) {
            this.status.textContent =
              applied && applied.applicable
                ? this.dataset.textApplied || 'Code applied.'
                : this.dataset.textInvalid || "This code isn't valid.";
          }

          if (this.status) window.twtLastDiscountStatus = { text: this.status.textContent, at: Date.now() };
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'twt-cart-discount', cartData: cart });
        } catch (error) {
          if (this.status) this.status.textContent = error.message;
        } finally {
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    }
  );
}
